import { css, FlattenSimpleInterpolation } from 'styled-components';

const setBreakpointStyle = (
  breakpoint: string,
  breakpointCSS: FlattenSimpleInterpolation,
  mediaWidth: 'min-width' | 'max-width' = 'min-width',
): FlattenSimpleInterpolation => {
  return css`
    @media (${mediaWidth}: ${breakpoint}) {
        ${breakpointCSS};
    }
  `;
};

export default setBreakpointStyle;
